import script from "./signup.vue?vue&type=script&setup=true&lang=js"
export * from "./signup.vue?vue&type=script&setup=true&lang=js"

import "./signup.vue?vue&type=style&index=0&id=41eb4c8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41eb4c8a"]])

export default __exports__